const IPtoNum = (ip: string) =>
  ip.split('.').reduce((acc, octet) => acc * 256 + Number(octet), 0);

/**
 * Checks if a given IP address is within a specified contiguous range.
 *
 * @param {string} value - The IP address to check, in string format.
 * @param {string} range - The IP range in the format "start-end", where start and end are IP addresses.
 * @returns A boolean indicating whether the IP address is within the specified range.
 */
export const isAddressInContiguousRange = (value: string, range: string) => {
  const [start, end] = range.split(/\s?-\s?/).map(IPtoNum);
  const ip = IPtoNum(value);
  return ip >= start && ip <= end;
};
